import { Spin } from 'antd';
import { useCallback, memo, forwardRef } from 'react';

const ListView = memo(
  forwardRef(function (
    {
      data,
      RenderFooter,
      RenderItem,
      inverted,
      loading,
      className,
      id,
      style = {},
      reversed,
      RenderEmpty
    },
    ref
  ) {
    const Empty = useCallback(() => (RenderEmpty ? <RenderEmpty /> : <></>), [RenderEmpty]);

    const Items = useCallback(
      ({ RenderItem }) =>
        data?.length
          ? (reversed ? data.slice().reverse() : data).map((item, key) => (
              <RenderItem
                item={item}
                key={typeof item === 'number' ? item : item?.id || key}
                messageRef={ref}
                index={key}
              />
            ))
          : !loading && <Empty />,
      [data, reversed, RenderEmpty, loading]
    );

    return (
      <div
        ref={ref}
        id={id}
        className={className}
        style={{
          transform: inverted && 'scaleY(-1)',
          ...style
        }}>
        {loading && <Spin />}
        <Items RenderItem={RenderItem} />
        {RenderFooter && <RenderFooter />}
      </div>
    );
  })
);

export default ListView;
